import React from "react";
import { Tag, Tooltip } from "antd";

export const newApps = (leng) => {
  return [
    {
      title: () => (
        <>
          App Name <Tag color="processing">{leng}</Tag>
        </>
      ),
      dataIndex: "new_app_name",
      key: "new_app_name",
      fixed: "left",
      sorter: (a, b) =>
        a.new_app_name ? a.new_app_name.localeCompare(b.new_app_name) : 1,
      responsive: ["sm"],
      width: "40%",
    },
    {
      title: "Category Name",
      dataIndex: "current_category",
      key: "current_category",
      fixed: "left",
      sorter: (a, b) =>
        a.current_category
          ? a.current_category.localeCompare(b.current_category)
          : 1,
      responsive: ["sm"],
      width: "40%",
    },
    {
      title: () => (
        <Tooltip placement="left" title={"Cloud Confidence Level"}>
          CCL
        </Tooltip>
      ),
      dataIndex: "current_ccl",
      key: "current_ccl",
      fixed: "left",
      sorter: (a, b) =>
        a.current_ccl ? a.current_ccl.localeCompare(b.current_ccl) : 1,
      responsive: ["sm"],
      width: "20%",
    },
  ];
};

export const chngCclApps = (leng) => {
  return [
    {
      title: () => (
        <>
          App Name <Tag color="processing">{leng}</Tag>
        </>
      ),
      dataIndex: "new_app_name",
      key: "new_app_name",
      fixed: "left",
      sorter: (a, b) =>
        a.new_app_name ? a.new_app_name.localeCompare(b.new_app_name) : 1,
      responsive: ["sm"],
      width: "35%",
    },
    {
      title: "Category Name",
      dataIndex: "current_category",
      key: "current_category",
      fixed: "left",
      sorter: (a, b) =>
        a.current_category
          ? a.current_category.localeCompare(b.current_category)
          : 1,
      responsive: ["sm"],
      width: "35%",
    },
    {
      title: () => (
        <Tooltip placement="left" title={"Old Cloud Confidence Level"}>
          Old CCL
        </Tooltip>
      ),
      dataIndex: "old_ccl",
      key: "old_ccl",
      fixed: "left",
      sorter: (a, b) => (a.old_ccl ? a.old_ccl.localeCompare(b.old_ccl) : 1),
      responsive: ["sm"],
      width: "15%",
    },
    {
      title: () => (
        <Tooltip placement="left" title={"New Cloud Confidence Level"}>
          New CCL
        </Tooltip>
      ),
      dataIndex: "current_ccl",
      key: "current_ccl",
      fixed: "left",
      sorter: (a, b) =>
        a.current_ccl ? a.current_ccl.localeCompare(b.current_ccl) : 1,
      responsive: ["sm"],
      width: "15%",
    },
  ];
};

export const domainChanges = (leng) => {
  return [
    {
      title: () => (
        <>
          App Name <Tag color="processing">{leng}</Tag>
        </>
      ),
      dataIndex: "new_app_name",
      key: "new_app_name",
      fixed: "left",
      sorter: (a, b) =>
        a.new_app_name ? a.new_app_name.localeCompare(b.new_app_name) : 1,
      responsive: ["sm"],
      width: "22%",
    },
    {
      title: "Type",
      dataIndex: "change_type",
      key: "change_type",
      sorter: (a, b) =>
        a.change_type ? a.change_type.localeCompare(b.change_type) : 1,
      responsive: ["sm"],
      width: "16%",
      render: (text) => {
        const color = text === "Remapped Domain" ? "orange" : "blue";
        return text ? <Tag color={color}>{text}</Tag> : "";
      },
    },
    {
      title: "Old Category",
      dataIndex: "old_category",
      key: "old_category",
      sorter: (a, b) =>
        a.old_category ? a.old_category.localeCompare(b.old_category) : 1,
      responsive: ["sm"],
      width: "18%",
    },
    {
      title: "New Category",
      dataIndex: "current_category",
      key: "current_category",
      sorter: (a, b) =>
        a.current_category
          ? a.current_category.localeCompare(b.current_category)
          : 1,
      responsive: ["sm"],
      width: "18%",
    },
    {
      title: "Domain",
      dataIndex: "new_domain",
      key: "new_domain",
      sorter: (a, b) =>
        a.new_domain ? a.new_domain.localeCompare(b.new_domain) : 1,
      responsive: ["sm"],
      width: "26%",
    },
  ];
};

export const catChngApps = (leng) => {
  return [
    {
      title: () => (
        <>
          App Name <Tag color="processing">{leng}</Tag>
        </>
      ),
      dataIndex: "new_app_name",
      key: "new_app_name",
      fixed: "left",
      sorter: (a, b) =>
        a.new_app_name ? a.new_app_name.localeCompare(b.new_app_name) : 1,
      responsive: ["sm"],
      width: "25%",
    },
    {
      title: "Old Category",
      dataIndex: "old_category",
      key: "old_category",
      fixed: "left",
      sorter: (a, b) =>
        a.old_category ? a.old_category.localeCompare(b.old_category) : 1,
      responsive: ["sm"],
      width: "37%",
    },
    {
      title: "New Category",
      dataIndex: "current_category",
      key: "current_category",
      fixed: "left",
      sorter: (a, b) =>
        a.current_category
          ? a.current_category.localeCompare(b.current_category)
          : 1,
      responsive: ["sm"],
      width: "38%",
    },
  ];
};

export const nameChngApps = (leng) => {
  return [
    {
      title: () => (
        <>
          Old App Name <Tag color="processing">{leng}</Tag>
        </>
      ),
      dataIndex: "old_app_name",
      key: "old_app_name",
      fixed: "left",
      sorter: (a, b) =>
        a.old_app_name ? a.old_app_name.localeCompare(b.old_app_name) : 1,
      responsive: ["sm"],
      width: "50%",
    },
    {
      title: "New App Name",
      dataIndex: "new_app_name",
      key: "new_app_name",
      fixed: "left",
      sorter: (a, b) =>
        a.new_app_name ? a.new_app_name.localeCompare(b.new_app_name) : 1,
      responsive: ["sm"],
      width: "50%",
    },
  ];
};

export const breachedApps = (leng) => {
  return [
    {
      title: () => (
        <>
          App Name <Tag color="processing">{leng}</Tag>
        </>
      ),
      dataIndex: "new_app_name",
      key: "new_app_name",
      fixed: "left",
      sorter: (a, b) =>
        a.new_app_name ? a.new_app_name.localeCompare(b.new_app_name) : 1,
      responsive: ["sm"],
      width: "40%",
    },
    {
      title: "Category Name",
      dataIndex: "current_category",
      key: "current_category",
      fixed: "left",
      sorter: (a, b) =>
        a.current_category
          ? a.current_category.localeCompare(b.current_category)
          : 1,
      responsive: ["sm"],
      width: "40%",
    },
    {
      title: "Breached Date",
      dataIndex: "breached_date",
      key: "breached_date",
      fixed: "left",
      width: "20%",
      defaultSortOrder: "descend",
      sorter: (a, b) => new Date(a.breached_date) - new Date(b.breached_date),
      render: (text) => <>{text !== null ? text : ""}</>,
    },
  ];
};

export const tabPageCss = {
  padding: "0",
  marginBottom: "0",
};

export const cardCss = { padding: "0", borderStyle: "hidden" };
